// src/App.jsx
import React from "react";
import { Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Sidebar from "./components/Sidebar";
import ProtectedRoute from "./components/ProtectedRoute";

import bg from "./assets/bg.png";

import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import SolveQuestion from "./components/SolveQuestion";
import ResetPassword from "./pages/ResetPassword";
import Profile from "./pages/Profile";
import AdminPanel from "./pages/AdminPanel";
import Payment from "./components/Payment"
import { AuthProvider } from "./context/AuthContext";
import UserPanel from "./pages/UserPanel";
import TransactionHistory from "./pages/TransactionHistory";

function App() {
  return (
    <AuthProvider>

      <div className="flex h-screen ">
        {/* Sidebar */}
        <Sidebar />

        {/* Main Content */}
        <div className="flex flex-col flex-1">
          <Navbar />

          <main
            className="flex-1 p-4 overflow-y-auto bg-cover bg-center"
            style={{ backgroundImage: `url(${bg})` }}
          >
            <Routes>
              {/* Public Routes */}
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/reset-password" element={<ResetPassword />} />

              {/* Protected Routes */}
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/solve"
                element={
                  <ProtectedRoute>
                    <UserPanel />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/solve"
                element={
                  <ProtectedRoute>
                    <UserPanel />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/premium"
                element={
                  <ProtectedRoute>
                    <Payment />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/solve/:questionId"
                element={
                  <ProtectedRoute>
                    <SolveQuestion />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/profile"
                element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                }
              />

               <Route
                path="/history"
                element={
                  <ProtectedRoute>
                    <TransactionHistory/>
                  </ProtectedRoute>
                }
              />

              {/* Admin Route */}
              <Route
                path="/admin"
                element={
                  <ProtectedRoute role="Admin">
                    <AdminPanel />
                  </ProtectedRoute>
                }
              />

              {/* Default Route */}
              <Route path="*" element={<Login />} />
            </Routes>
          </main>
        </div>
      </div>

    </AuthProvider>
  );
}

export default App;

